// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LaborAdditivePipsAside from './labor-additive-pips-aside';
import LaborAdditivePipsMain from './labor-additive-pips-main';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

const LaborAdditivePips = props =>
    <section className='labor-additive-pips'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <LaborAdditivePipsAside/>
        <LaborAdditivePipsMain/>
    </section>;

LaborAdditivePips.displayName = 'LaborAdditivePips';
LaborAdditivePips.propTypes = {
    busyCounter: PropTypes.number.isRequired
};

export default LaborAdditivePips;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips.js